module.exports = __webpack_public_path__ + "static/media/menuCalendar.dd8b57fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuCalendar.svg
// module id = 464
// module chunks = 0